import axios from 'axios';

const config = {
	headers: {
		'x-access-token': sessionStorage.token,
	},
};

let host = 'http://localhost:8000/';
if (process.env.NODE_ENV === 'production') {
	host = 'https://reale-server.herokuapp.com/';
}
const url = `${host}api/geolocation`;
const urldemo = `${host}api/geolocationdemo`;

const getAutocompleteByText = (q: string) => axios.get(`${url}/${q}`, config);

const getAutocompleteByDemoText = (q: string) =>
	axios.get(`${urldemo}/${q}`, config);

// //ONLY FOR LANDING PAGE - OPEN TO ALL
// const getLandingJob = (id) => {
// 	return axios.get(url2 + '/' + id);
// };

export default {
	getAutocompleteByText,
	getAutocompleteByDemoText,
};
